import React from 'react';
import './Availability.css'
function Availability() {
  return (
    <div>
       <section className="sec">
<div><h2 className='maineasya'>Easy Availability and Accessibility</h2>
    <div className="easy">
    <div className="Avilcard1">
        <div className='AvilcardStyle'>
            <div className='stickerStyles'>
           <div className="sticker">
           <img src="https://ik.imagekit.io/zn4au2jftpm5/customer-support_wPk-OuZ23.png" alt="Description of Image"class="supportimage" />
           </div>
           </div>
    <h3 className="custom">Customer Support</h3>
    <p className='easypera'>Our support team merges technical prowess with sincere care, fostering trust through expertise and empathy. They build lasting relationships, transcending mere service to create meaningful connections.</p>
    </div>
</div>
        <div className="availcard2">
            <div className="cd1">
            <div className="c1">
                <div className="icon1">
                <img src="https://ik.imagekit.io/zn4au2jftpm5/setting_z7IzKFspuo.png" alt="Description of Image" class="supportimage"/>
                </div>
                   <div className="txt1"><h3 className="Swift">AI Enabled Apps</h3>
                       <p className="easypera">Our innovative apps are built with the options of Azure AI, Copilot, and custom AI solutions.</p>
                    </div>
            </div>
               
                <div className="c2">
                <div className="icon2">
                    <img src="https://ik.imagekit.io/zn4au2jftpm5/interface%20(1)_Bn8jFsKJE.png" alt="Description of Image"class="supportimage" />
                </div>
                    <div className="txt2">
                    <h3 className="Swift">Modern UI/UX</h3>
                    <p className="easypera">Every app is crafted using the latest Fluent UI, ensuring seamless functionality across all devices.</p>
                    </div>
                </div>
            </div>
            <div className="cd2">
                <div className="c3">
                  <div className="icon3">
                  <img src="https://ik.imagekit.io/zn4au2jftpm5/cloud-storage_wjvbbJkVt.png" alt="Description of Image" class="supportimage"/>
                  </div>
                    <div className="txt3"><h3 className="Swift">Swift Deployment​</h3>
                    <p className="easypera">Choose any deployment method—Teams, Outlook, or SharePoint—that suits your preferences.</p>
                    </div>
                </div>
                <div className="c4">
                    <div className="icon4">
                    <img src="https://ik.imagekit.io/zn4au2jftpm5/refresh__OBoe0tcU.png" alt="Description of Image" class="supportimage"/>
                    </div>
                    <div className="txt4"><h3 className="Swift">Free Updates </h3>
                    <p className="easypera">Our valued subscribers enjoy unlimited support, enhancements, features, and updates.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</section>
    </div>
  )
}
export default Availability;